import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule, MatDialogModule, MatIconModule, MatDatepickerModule, MatFormFieldModule, MatSelectModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FuseSharedModule } from '@fuse/shared.module';

import { UpdateTripDialogComponent } from './update-trip-dialog.component';

@NgModule({
    declarations: [
        UpdateTripDialogComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatIconModule,
        MatDatepickerModule,
        CommonModule,
        NgxMatSelectSearchModule,
        FuseSharedModule
    ],
    entryComponents: [
        UpdateTripDialogComponent
    ],
})
export class UpdateTripDialogModule
{
}
